<template>
  <div
    class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1"
  >
    <div class="p-2">
      <!-- <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActiveSendNews)"
        variant="primary"
        block
        @click="$emit('open-send-news')"
      > -->
        <!-- @click="$emit('update:isEventHandlerSidebarActiveSendNews', true)" -->
        <!-- Nova noticia
      </b-button> -->
      <!-- <b-button
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="secondary"
        block
        @click="$emit('submit-import-event')"
      >
        Importar
      </b-button> -->

      <!-- <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Origem</span>
        </h5>
        <b-form-group>
          <v-select
            id="origin-list"
            v-model="selectedOrigins"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            multiple
            class="form-control-sm"
            :placeholder="$t('MANAGE_NEWS_FILTER.Origin')"
            :options="originOptions"
            :reduce="option => option.id"
          >
            <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
          </v-select>
        </b-form-group>
      </div> -->

      <div class="mt-1">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Tipo de Notícia</span>
        </h5>
        <!-- <b-form-checkbox v-model="checkAll" class="mb-1">
          Ver Todos
        </b-form-checkbox> -->
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedNewsType"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="(item, index) in newsTypeOptions"
              :key="index"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`${item.color}-border`"
              :checked="item.id"
            >
              {{ item.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="mt-1">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Tipo de evento</span>
        </h5>
        <!-- <b-form-checkbox v-model="checkAll" class="mb-1">
          Ver Todos
        </b-form-checkbox> -->
        <b-form-group>
          <!-- <b-form-checkbox-group
            id="checkbox-subejcts"
            v-model="selectedDisclosureType"
            :options="disclosureTypeOptions"
            value-field="id"
            text-field="name"
            name="flavour-1"
            class="demo-inline-spacing"
          /> -->

          <b-form-checkbox-group
            v-model="selectedDisclosureType"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="(item, index) in disclosureTypeOptions"
              :key="index"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`${item.color}-border`"
              :checked="true"
            >
              {{ item.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <!-- <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Origens</span>
        </h5>
        <b-form-checkbox v-model="checkAll" class="mb-1">
          Ver Todos
        </b-form-checkbox>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedOrigins"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="(item, index) in originOptions"
              :key="index"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`custom-control-${item.color}`"
            >
              {{ item.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div> -->
      <!-- <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Região</span>
        </h5>
        <b-list-group class="list-group-messages" flush>
          <b-list-group-item
            v-for="region in regionOptions"
            :key="region.id"
            class="cursor-pointer"
            :class="{ 'selected-item': isRegionSelected(region) }"
            @click="selectRegion(region)"
          >
            <b-img
              v-if="region.locale.img"
              :src="region.locale.img"
              height="14px"
              width="22px"
              :alt="region.locale.locale"
              style="margin-right: 5px"
            />
            <span class="align-text-bottom line-height-1">{{
              region.name
            }}</span>
          </b-list-group-item>
        </b-list-group>
      </div> -->
    </div>
    <b-img :src="require('@/assets/images/pages/calendar-illustration.png')" />
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BImg,
  // BListGroup,
  // BListGroupItem,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import useCalendarSidebar from "./useCalendarSidebar";
import store from "@/store";
// import vSelect from "vue-select";

export default {
  directives: {
    Ripple,
  },
  components: {
    
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
    // vSelect,
    // BListGroup,
    // BListGroupItem,
  },
  props: {
    isEventHandlerSidebarActiveSendNews: {
      type: Boolean,
      require: true,
    },
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
  },
  methods: {
    isRegionSelected(region) {
      // console.log(store.state.calendar.selectedRegion);
      return region.id == store.state.calendar.selectedRegion;
    },
    selectRegion(region) {
      // console.log('selectRegion', region.id)
      store.commit("calendar/SET_SELECTED_REGION", region.id);
      this.$forceUpdate();
    },
  },
  computed: {},
  setup() {
    // const isRegionSelected = (region) => {};

    const {
      newsTypeOptions,
      selectedNewsType,
      disclosureTypeOptions,
      selectedDisclosureType,
      originOptions,
      regionOptions,
      selectedOrigins,
      checkAll,
      importingData
    } = useCalendarSidebar();

    return {
      newsTypeOptions,
      selectedNewsType,
      disclosureTypeOptions,
      selectedDisclosureType,
      originOptions,
      regionOptions,
      selectedOrigins,
      checkAll,
      importingData
    };
  },
};
</script>

<style>
</style>
